import { Extra } from "src/app/core/services/action.service";
import { alertPresets } from "../../services/alert.service";
import { SweetAlertOptions } from "sweetalert2";

export const XLSX = 'Excel';
export const CSV = 'CSV';
export const CSV_ALL = 'CSV All';
export const PDF = 'PDF';

export const exportOptions = [XLSX, CSV, CSV_ALL,PDF];
export const exportOptions2 = [XLSX, CSV, CSV_ALL, PDF];
export const exportOptions3 = [XLSX, CSV];

export const pageSizeOptions = [10, 25, 50, 100, 500];

export enum type {
    Datatable,
    Client,
    Account
}

export const alertDefaultExtra: Extra = {
    success: {
      show: true,
      message: '',
      title: '',
      showSwal: false,
      alertOptions: <SweetAlertOptions>alertPresets.saveSuccess,
    },
    error: {
      show: true,
      title: '',
      showResponseError: false, // show error comming in response
    },
  };

  export const createdbyRegex = new RegExp('^(tbl[0-9]+_)+createdby$');
  export const modifiedbyRegex = new RegExp('^(tbl[0-9]+_)+modifiedby$');
  export const datecreatedRegex = new RegExp('^(tbl[0-9]+_)+datecreated$');
  export const datemodifiedRegex = new RegExp('^(tbl[0-9]+_)+datemodified$');
